import React, { useEffect, useState } from "react";
import { Table } from "semantic-ui-react";
import axios from "axios";

import MyLoader from "../../sharecomponents/MyLoader";
import { PHP_API } from "../../../utils/Common";

const InventarioVivero = (props) => {
  const [loader, setLoader] = useState(false);
  const [inventario, setInventario] = useState([]);

  useEffect(() => {
    getInvVivero();
  }, []);

  function getInvVivero() {
    setLoader(true);
    axios.get(PHP_API + "get_inv_vivero").then((r) => {
      console.log(r.data);
      setInventario([...r.data.inventario]);
      setLoader(false);
    });
  }

  /**
   * Custom Style
   */
  const cellHeader = {
    textAlign: "center",
    background: "rgb(111, 45, 30)",
    color: "#fff",
    fontweight: "bold",
    fontsize: "16px",
  };

  return (
    <React.Fragment>
      <div className="w-full p-3 right-0">
        <div className="bg-white border rounded shadow-xl">
          <div className="border-b rounded-t p-3 bg-orange-900">
            <h5 className="font-bold uppercase text-white">
              Inventario de Vivero
            </h5>
            <p className="text-white text-sm">Reporte de Inventario de Vivero</p>
          </div>
          <div className="p-5 rounded-b">
            {/* ---- CONTENIDO --- */}
            <Table striped celled size="small">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell style={cellHeader}>Flor</Table.HeaderCell>
                  <Table.HeaderCell style={cellHeader}>Semena Inicio</Table.HeaderCell>
                  <Table.HeaderCell style={cellHeader}>Semana Transplante</Table.HeaderCell>
                  <Table.HeaderCell style={cellHeader}>Total Ejecutado</Table.HeaderCell>
                  <Table.HeaderCell style={cellHeader}>En Siembra<br />(Charolas)</Table.HeaderCell>
                  <Table.HeaderCell style={cellHeader}>En Aclimatación<br />(Charolas)</Table.HeaderCell>
                  <Table.HeaderCell style={cellHeader}>Listas Transplante<br />(Charolas)</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {inventario.map((inv, i) => {
                  return (
                    <Table.Row key={i}>
                      <Table.Cell>{inv.flor} {inv.variedad} {inv.color}</Table.Cell>
                      <Table.Cell style={{textAlign: 'center'}}>{inv.semanainicio}</Table.Cell>
                      <Table.Cell style={{textAlign: 'center'}}>{inv.transplante}</Table.Cell>
                      <Table.Cell style={{textAlign: 'right'}}>{inv.total_ejecutado}</Table.Cell>
                      <Table.Cell style={{textAlign: 'right'}}>{inv.backorder}</Table.Cell>
                      <Table.Cell style={{textAlign: 'right'}}>{inv.inv_aclimatacion}</Table.Cell>
                      <Table.Cell style={{textAlign: 'right'}}>{inv.inv_transplante}</Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </div>
        </div>
      </div>

      {loader && <MyLoader />}
    </React.Fragment>
  );
};

export default InventarioVivero;
